const InlineEditor = require('@ckeditor/ckeditor5-build-inline/build/ckeditor')

let gEditor;

document.addEventListener("turbolinks:load", () => {
  if ( document.querySelector( '#settings_info_info_div' ) != null ){
    InlineEditor
      .create( document.querySelector( '#settings_info_info_div' ), {
          toolbar: [ 'fontColor', 'fontBackgroundColor', '|', 'bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo' ],
          placeholder: 'Info'
      }  )
      .then( editor => {
          console.log( editor );
          console.log(Array.from( editor.ui.componentFactory.names()));
          gEditor = editor;
          // editors.push(editor);
      })
      .catch( error => {
          console.log( error );
      });
    if (document.querySelector( '#si_form' ) != null){
      document.querySelector( '#si_form' ).addEventListener( 'submit', () => {
        $('#settings_info_info').val(gEditor.getData())
      } );
    }
  }
});
